/**
 * Central place for reading auth token (useAuth stores `jwt`; legacy code uses `token`).
 */
export function getToken() {
  const jwt = localStorage.getItem('jwt');
  if (jwt && jwt !== 'null' && jwt.trim() !== '') return jwt;
  const t = localStorage.getItem('token');
  if (t && t !== 'null' && t.trim() !== '') return t;
  return '';
}
